module.exports = __webpack_public_path__ + "static/media/19 - Drugdealer - Honey.df0ff359.mp3";